module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG607ad099682ec6a3b46979a53ef9d1aa.607ad099.png";